export default {
  data() {
    return {
      searchForm: {
        type: '',
        yearStart: '',
        yearEnd: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          title: '序号',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '财报名称',
          width: 180,
          dataIndex: 'fileName',
        },
        {
          title: '提报时间',
          width: 100,
          dataIndex: 'reportTime',
        },
        {
          title: '上传人',
          width: 120,
          dataIndex: 'operator',
        },
        {
          title: '上传时间',
          width: 120,
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((error, values) => {
        this.searchForm = values
        this.pageData.current = 1
        this._getTableData()
      })
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
